import React, { useState, useEffect } from 'react';
// Common Components (Corrected Paths)
import AppPaginator from '../../AppPaginator';
import AppSearchBox from '../../AppSearchBox';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import PerPageBlock from '../../common/PerPageBlock';
import AppToaster from '../../AppToaster';
// API & Utils (Corrected Paths)
import { getPurchaseInvoices, fetchPurchaseInvoice, destroyPurchaseInvoice /*, destroyPurchaseInvoicesMultiple*/ } from '../../../api/PurchaseInvoicesAPI'; // Added imports
import { handleApiError } from '../../../api/risapi';
// Report component if needed
// import PurchaseInvoicesReport from './PurchaseInvoicesReport';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { format, parseISO } from 'date-fns'; // For formatting date

const PurchaseInvoicesPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const successMessage = location.state?.message;

    const [entityName, setEntityName] = useState('Purchase Invoice');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [reportLoading, setReportLoading] = useState(false);
    const [viewDataLoading, setViewDataLoading] = useState(false);
    const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [perPage, setPerPage] = useState(process.env.REACT_APP_PER_PAGE_COUNT || 10);
    const [enableMultipleItemSelect, setEnableMultipleItemSelect] = useState(false);
    const [selectedInvoiceIds, setSelectedInvoiceIds] = useState(new Set());

    const [invoicesList, setInvoicesList] = useState({
        paginate: true, data: [], per_page: perPage, current_page: 1, tot_page: null,
    });

    const [toaster, setToaster] = useState({});
    const [showToaster, setShowToaster] = useState(false);
    const [saveCompleted, setSaveCompleted] = useState(false); // Triggers refresh

    // --- Navigation ---
    const handleAddClick = () => navigate('/franchisee_user/inventory/purchase-invoices/create'); // Correct route
    const handleEditClick = (id) => navigate(`/franchisee_user/inventory/purchase-invoices/edit/${id}`); // Correct route
    // Optional: Handler to view details
    // const handleViewClick = (id) => navigate(`/franchisee_user/inventory/purchase-invoices/view/${id}`);

    // --- Delete Logic ---
    const handleDeleteClick = (id) => {
        fetchPurchaseInvoice(id, function (result) { // Use fetchPurchaseInvoice
            if (result.purchase_invoice) {
                const deleteItem = result.purchase_invoice;

                // ** Optional Check: Prevent deletion if GRN exists **
                // Note: This relies on the 'goodsReceivedNotes' relation being loaded by fetchPurchaseInvoice
                // if (Array.isArray(deleteItem.goods_received_notes) && deleteItem.goods_received_notes.length > 0) {
                //     Swal.fire('Cannot Delete', 'Goods have already been received against this invoice. Delete the GRN first.', 'warning');
                //     return;
                // }

                Swal.fire({
                    title: 'Are you sure?',
                    html: `
                        <p>Delete Purchase Invoice:</p>
                        <ul class="delete-details-list">
                            <li><strong>ID:</strong> ${deleteItem.id}</li>
                            <li><strong>Supplier Inv No:</strong> ${deleteItem.invoice_number || 'N/A'}</li>
                            <li><strong>Date:</strong> ${deleteItem.invoice_date}</li>
                            <li><strong>Supplier:</strong> ${deleteItem.party?.name || 'N/A'}</li>
                            <li><strong>Amount:</strong> ${parseFloat(deleteItem.total_amount || 0).toFixed(2)}</li>
                        </ul>
                        <p>This action cannot be undone.</p>`,
                    icon: 'warning', showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#6c757d', confirmButtonText: 'Yes, delete it!'
                }).then((dialogResult) => {
                    if (dialogResult.isConfirmed) {
                        destroyPurchaseInvoice(deleteItem, function (apiResponse) { // Use destroyPurchaseInvoice
                            if (apiResponse.purchase_invoice) {
                                Swal.fire('Deleted!', 'Record deleted.', 'success');
                                setSaveCompleted(prev => !prev); // Trigger refresh
                            } else {
                                // Display specific backend error (like conflict)
                                Swal.fire('Error!', apiResponse.error?.response?.data?.message || 'Could not delete invoice.', 'error');
                            }
                        });
                    }
                });
            } else { Swal.fire('Error!', 'Could not fetch invoice details.', 'error'); }
        });
    };

    // ** NEW HANDLER **
    const handleCreateGrnClick = (invoiceId) => {
        // Navigate to new GRN page with query params
        navigate(`/franchisee_user/inventory/grn/create?source_type=PurchaseInvoice&source_id=${invoiceId}`);
    };

    // --- Multi-Delete Logic (Placeholder - Implement if needed) ---
     const showMultipleDeleteConfirmation = () => {
         // ** Add checks for GRNs before proceeding **
         Swal.fire('Not Implemented', 'Multi-delete needs careful checks for linked GRNs.', 'info');
         // const deletingItems = invoicesList.data.filter(...);
         // if (deletingItems.length === 0) { /* ... */ return; }
         // Swal.fire({ /* ... */ }).then((result) => {
         //     if (result.isConfirmed) {
         //         const idsToDelete = Array.from(selectedInvoiceIds);
         //         // destroyPurchaseInvoicesMultiple(idsToDelete, function (response) { /* ... */ });
         //     }
         // });
     };

    // --- Checkbox Handler ---
    const handleCheckboxChange = (id, isChecked) => {
        setSelectedInvoiceIds(prev => {
            const newSet = new Set(prev);
            if (isChecked) newSet.add(id); else newSet.delete(id);
            return newSet;
        });
    };

    // --- Effects ---
    useEffect(() => {
        if (successMessage) {
            setShowToaster(true);
            setToaster({ type: 'success', heading: 'Success', message: successMessage });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [successMessage, location.pathname, navigate]);

    useEffect(() => {
        document.title = 'Manage Purchase Invoices';
        let filters = { paginate: true, page: currentPage, per_page: perPage, search_term: searchTermCompleted };
        setViewDataLoading(true);
        setSelectedInvoiceIds(new Set());
        setEnableMultipleItemSelect(false);

        getPurchaseInvoices(filters, function (response) { // Use getPurchaseInvoices
            setViewDataLoading(false);
             // Handle paginated or simple array response
             if (response.purchase_invoices) {
                 let data = []; let currentP = 1; let lastP = 1; let responsePP = perPage;
                 if (Array.isArray(response.purchase_invoices)) { data = response.purchase_invoices; }
                 else if (response.purchase_invoices.data && Array.isArray(response.purchase_invoices.data)) {
                     data = response.purchase_invoices.data; currentP = response.purchase_invoices.current_page; lastP = response.purchase_invoices.last_page; responsePP = response.purchase_invoices.per_page;
                 } else { console.error("Unexpected API structure:", response.purchase_invoices); handleApiError(response); return; }
                 setInvoicesList({ paginate: filters.paginate, per_page: responsePP, data: data, current_page: currentP, tot_page: lastP });
             } else {
                  handleApiError(response);
                  setToaster({ type: 'danger', heading: 'Error', message: 'Could not load Purchase Invoices.' });
                  setShowToaster(true);
                  setInvoicesList(prev => ({ ...prev, data: [], current_page: 1, tot_page: 1 })); // Safe reset
             }
        });
    }, [currentPage, searchTermCompleted, saveCompleted, perPage]);

    // Helper to format date
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return format(parseISO(dateString), 'dd-MMM-yyyy'); // Use parseISO for YYYY-MM-DD
        } catch (error) { return dateString; }
    };

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title='Purchase Invoices List'>
                        <li><a className="f-s-14 f-w-500" href="#">Inventory</a></li>
                        <li className="active"><a className="f-s-14 f-w-500" href="#">Purchase Invoices</a></li>
                    </AppBreadCrumb>

                    <div className="row bg-white">
                        <div className="col-12">
                            <div className="tab-wrapper mb-3">
                                {/* ... (Tabs and Action Buttons as before) ... */}
                                <ul className="tabs">
                                     <li className="tab-link active" data-tab={1}>All Purchase Invoices</li>
                                     <li className="ms-md-auto">
                                         <div className="text-md-end d-flex flex-column flex-md-row mt-md-3">
                                             <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />
                                             <button className="text-nowrap btn btn-red btn-sm ms-md-3 fw-semibold f-s-14" type="button" onClick={handleAddClick}>
                                                 <i className="ph-bold  ph-circles-three-plus"></i> Add Purchase Invoice
                                             </button>
                                             {/* Add PurchaseInvoicesReport component here */}
                                         </div>
                                     </li>
                                 </ul>
                            </div>
                            <div className="content-wrapper" id="card-container">
                                <div className="d-flex flex-wrap m-md-3">
                                    {invoicesList.data.length > 0 ? (
                                        <>
                                            <AppPaginator entityName={entityName} currentPage={invoicesList.current_page} totalPages={invoicesList.tot_page} setCurrentPage={setCurrentPage} />
                                            <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                                            <div className='d-flex align-items-center ms-auto mt-2 mt-md-0'>
                                                 {/* Multi-select button placeholder */}
                                                 {/* <button ... onClick={() => setEnableMultipleItemSelect(prev => !prev)}>...</button> */}
                                                 {/* <button ... onClick={showMultipleDeleteConfirmation}>...</button> */}
                                            </div>
                                        </>
                                    ) : ( !viewDataLoading && <p className="text-center w-100">No Purchase Invoices found.</p> )}
                                    {(reportLoading || viewDataLoading) && <div className="loader_box ms-auto"><div className="loader_14"></div></div>}
                                </div>

                                {/* --- Card Layout Start --- */}
                                <div className="tabs-content active" id="tab-1">
                                    <div className="row">
                                        {!viewDataLoading && invoicesList.data.map((invoice) => (
                                            <div className="col-md-6 col-xl-4 project-card" key={invoice.id}>
                                                <div className="card hover-effect">
                                                    <div className="card-header">
                                                        <div className="d-flex align-items-center">
                                                            {/* Checkbox (if multi-select enabled) */}
                                                            {/* {enableMultipleItemSelect && (<input ... />)} */}
                                                            <div className="h-40 w-40 d-flex-center b-r-50 overflow-hidden me-2 btn-light-reddit">
                                                                 <i className="ti ti-file-dollar f-s-18"></i> {/* Invoice Icon */}
                                                            </div>
                                                            <div className="flex-grow-1 ps-2">
                                                                <h6 className="m-0 text-dark f-w-600">{invoice.party?.name || 'N/A'}</h6>
                                                                <small className="text-muted d-block">Inv#: {invoice.invoice_number || '-'} | {formatDate(invoice.invoice_date)}</small>
                                                            </div>
                                                            <div className="dropdown">
                                                                <button aria-expanded="false" className="bg-none border-0" data-bs-toggle="dropdown" type="button"><i className="ti ti-dots-vertical text-dark" /></button>
                                                                <ul className="dropdown-menu dropdown-menu-end">
                                                                    {/* Optional: View Action */}
                                                                    {/* <li><a className="dropdown-item" onClick={() => handleViewClick(invoice.id)}><i className="ti ti-eye text-info me-1" /> View</a></li> */}
                                                                    <li><a className="dropdown-item" onClick={() => handleEditClick(invoice.id)}><i className="ti ti-edit text-success me-1" /> Edit</a></li>
                                                                    <li><button className="dropdown-item delete-button" onClick={() => handleDeleteClick(invoice.id)}><i className="ti ti-trash text-danger me-1" /> Delete</button></li>
                                                                    <li>
                     <button className="dropdown-item" onClick={() => handleCreateGrnClick(invoice.id)}>
                         <i className="ti ti-package text-primary me-1"></i> Receive Goods (GRN)
                     </button>
                 </li>
                                                                     {/* Optional: Manual GRN Creation Button */}
                                                                    {/* { (!invoice.goods_received_notes || invoice.goods_received_notes.length === 0) &&
                                                                        <li><hr className="dropdown-divider"/></li>
                                                                        <li><button className="dropdown-item" onClick={() => navigate(`/franchisee_user/inventory/grn/create/${invoice.id}`)}><i className="ti ti-truck-delivery text-primary me-1" /> Receive Goods</button></li>
                                                                    } */}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-body py-2">
                                                         <div className="d-flex justify-content-between align-items-center">
                                                             <div>
                                                                  <p className="f-w-500 text-secondary mb-0">Total Amount</p>
                                                                  <h6 className="f-w-600 mb-0">₹{parseFloat(invoice.total_amount || 0).toFixed(2)}</h6>
                                                             </div>
                                                              {/* Optional: GRN Status */}
                                                              {/* <div className='text-end'>
                                                                 <p className="f-w-500 text-secondary mb-0">GRN Status</p>
                                                                 { (invoice.goods_received_notes && invoice.goods_received_notes.length > 0)
                                                                     ? <span className='badge bg-success'>Received</span>
                                                                     : <span className='badge bg-warning text-dark'>Pending</span> // Added text-dark for contrast
                                                                 }
                                                              </div> */}
                                                         </div>
                                                     </div>
                                                </div>
                                            </div>
                                        ))}
                                        {/* No Data Card */}
                                        {!viewDataLoading && invoicesList.data.length === 0 && (
                                            <div className="col-12"> <div className="card mb-3"><div className="row g-0"><div className="col-md-12"><div className="card-body"><h5 className="card-title">No Purchase Invoices Found</h5><p className="card-text">No records match your criteria or no invoices added yet.</p></div></div></div></div></div>
                                        )}
                                    </div>
                                </div>
                                {/* --- Card Layout End --- */}

                                {/* <div className="d-flex flex-wrap m-md-3">
                                     {invoicesList.data.length > 0 && (
                                         <AppPaginator entityName={entityName} currentPage={invoicesList.current_page} totalPages={invoicesList.tot_page} setCurrentPage={setCurrentPage} />
                                     )}
                                 </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default PurchaseInvoicesPage;